export const dbCollections = {
    Productos: "Productos",
		Cart: "Cart"
};